/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateWhatsAppDisplayNameDataSchema = z.object({
	name: z.string(),
})

export type UpdateWhatsAppDisplayNameDataSchema = z.infer<typeof updateWhatsAppDisplayNameDataSchema>
